module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Man In The Mirror: Solving The 24 Problems Men Face")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0023-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#p0013-Anch-3"
    }
  }, [_vm._v("A NEW INTRODUCTION FROM THE AUTHOR ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0023-02-1"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("T")])]), _vm._v("he world has changed dramatically over the last twenty-five years. The once dependable consensus of Judeo-Christian values has melted away faster than a polar ice cap. Today, nearly half of our women would rather live with a man than marry him. And one-third of our children are not living with their biological dads.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-03-4"
    }
  }, [_vm._v("The last twenty-five years have been dominated by the digital revolution. The Internet has only been with us since the mid-1990s — just long enough to have made Steve Jobs rich enough to build a $250 million super yacht that can be operated from an iPad. He died without ever being able to see it, but I did, just two days before I wrote this — a vacant ghost ship, hauntingly moored to a berth at a marina in Florida.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-04-7"
    }
  }, [_vm._v("How did it happen that we take body searches for granted, and welcome metal detectors into our schools? Whether it’s the Great Recession, Wall Street corruption, political gridlock, social media, shifting demographics, terrorism, or the Department of Homeland Security — these are but a few of the tectonic changes that have rocked our world these last few years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-05-9"
    }
  }, [_vm._v("Yet when it comes to what it takes to be a man, not much has changed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-06-11"
    }
  }, [_vm._v("Frankly, when my colleagues asked me to update "), _c('i', [_vm._v("The Man in ")]), _vm._v(" "), _c('i', [_vm._v("the Mirror")]), _vm._v(", I wasn’t sure it was a good idea. However, in light of the dramatic changes just mentioned, it quickly became apparent that a whole new generation of men might benefit from taking a fresh look at how to solve the 24 problems men face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Actually, the solutions to most of the problems you and I face are surprisingly simple. But as with any skill you want to master, you have to have the right information. So my goal in this new edition of "), _c('i', [_vm._v("The Man in the Mirror")]), _vm._v(" is to help you address the unique challenges these 24 problems present as you find your way in the twenty-first century.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-03-4"
    }
  }, [_vm._v("When I wrote the original edition of "), _c('i', [_vm._v("The Man in the Mirror")]), _vm._v(", I wasn’t a writer at all; I was in commercial real estate. Now, the fact that millions of copies have been distributed around the world — well, there’s no question that God performed a miracle with that first book. And so I’ve resisted the urge to change those original, direct, plainspoken sentences that put into words what so many millions of men wanted — or needed — to hear in the first place. It was less about writing craft anyway, and more about what God wanted to do in men’s lives — how He was moving in the world. Some who read it became Christians. Others realized they had been more cultural Christians than biblical Christians. Many reordered their priorities and, in the process, saved their marriages and families. In short, God used that book to inspire and guide an entire generation of men.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-04-6"
    }
  }, [_vm._v("Now I’m praying that it might inspire and guide you too. What does God want to do in "), _c('i', [_vm._v("your")]), _vm._v(" life? If you’re ready, turn the page and let’s get started!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbaac30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 78
// module chunks = 0